import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import urls, { codeUrl, requestUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ items }) {
  const itemsWithUrls = items.map((item) => (item.isNew
    ? item.steps.sourceUrl || codeUrl(urls.REQUEST, item.code)
    : requestUrl(item)));

  yield call(listener.closeTab, itemsWithUrls);
}

export function* navigateToNewRequest({ result, previousUrl }) {
  yield call(listener.navigate, {
    type: actions.NEW_REQUEST_SUCCESS,
    code: result.code,
    previousUrl,
    name: result.name,
    description: result.description,
    url: requestUrl(result),
  });
}

export default function* requestsLayout() {
  yield takeEvery(actions.DESTROY_REQUESTS, closeTab);
  yield takeEvery(actions.NEW_REQUEST_SUCCESS, navigateToNewRequest);
}
